import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackBarStatus } from 'src/app/shared/models/constants/snackbar-status';

export interface SnackBarData {
  message: string;
  status: SnackBarStatus;
}

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Custom snackbar
 */
export class SnackBarComponent {
  /**
   * @constructor
   */
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData) {}

  /**
   * @param {string} str
   * @return {string}
   */
  isStatus(str: string): boolean {
    return this.data.status.toString() === str;
  }

  /**
   * checks if status is info
   */
  get info() {
    return this.isStatus('info');
  }

  /**
   * checks if status is warning
   */
  get warning() {
    return this.isStatus('warning');
  }

  /**
   * checks if status is success
   */
  get success() {
    return this.isStatus('success');
  }

  /**
   * checks if status is error
   */
  get error() {
    return this.isStatus('error');
  }

  /**
   * checks if status is neutral
   */
  get neutral() {
    return this.isStatus('neutral');
  }

  /**
   * gets message
   */
  get message() {
    return this.data.message;
  }

  /**
   * @return {string}
   */
  getIcon(): string {
    switch (this.data.status) {
      case SnackBarStatus.NEUTRAL:
        return 'sms_failed';
      case SnackBarStatus.ERROR:
        return 'pan_tool';
      case SnackBarStatus.INFO:
        return 'download';
      case SnackBarStatus.SUCCESS:
        return 'download_done';
      case SnackBarStatus.WARNING:
        return 'warning';
    }
  }
}
